import { isEvForeignTradeAnswered } from "../../searchFlowVersionB/steps/ev/EvForeignTrade.jsx";
import { isCompanyTaxForm } from "../../searchFlowVersionB/steps/company/CompanyTaxForm.jsx";
import KftRegActivityDescription from "../steps/KftRegActivityDescription.jsx";
import KftRegForeignTrade from "../steps/KftRegForeignTrade.jsx";
import KftRegIndustryActivity from "../steps/KftRegIndustryActivity.jsx";
import KftRegIndustrySelect from "../steps/KftRegIndustrySelect.jsx";
import KftRegTaxForm from "../steps/KftRegTaxForm.jsx";

const guardNextStep = (onNext, nextDisabled) => () => {
  if (nextDisabled) {
    return;
  }
  onNext?.();
};

const getIndustrySelectFooterNav = (self, onBack, onNext) => {
  const selectedIndustry = self.props.company_store?.industry || "";
  const industryInput = self.props.company_store?.industryinput || "";
  const isOtherSelected = selectedIndustry === "other";
  const nextDisabled =
    !selectedIndustry || (isOtherSelected && !String(industryInput).trim());

  return {
    onBack,
    onNext: guardNextStep(onNext, nextDisabled),
    nextDisabled,
  };
};

/** Footer config for the active KftRegFlow step — KftRegContactPage/KftRegSuccessScreen/GeneralError render their own nav. */
export const getKftRegStepFooterNav = (self, activeStep, steps) => {
  const stepComponent = steps[activeStep]?.component;
  if (!stepComponent) {
    return null;
  }

  if (stepComponent === KftRegIndustrySelect) {
    return getIndustrySelectFooterNav(
      self,
      // No back button on a direct landing — there's nowhere sensible to send it.
      self.state.cameFromNewCompanyType ? self.handleKftRegIndustrySelectBack : undefined,
      self.handleKftRegIndustrySelectNext,
    );
  }

  if (stepComponent === KftRegIndustryActivity) {
    return {
      onBack: self.handleKftRegIndustryActivityBack,
      onNext: self.handleKftRegIndustryActivityNext,
      nextDisabled: false,
    };
  }

  if (stepComponent === KftRegActivityDescription) {
    const nextDisabled = !String(self.props.company_store?.reqMessage || "").trim();
    return {
      onBack: self.handleKftRegActivityDescriptionBack,
      onNext: guardNextStep(self.handleKftRegActivityDescriptionNext, nextDisabled),
      nextDisabled,
    };
  }

  if (stepComponent === KftRegTaxForm) {
    const taxform = self.props.company_store?.taxform;
    const nextDisabled =
      !self.state.kftRegTaxFormInteracted || !isCompanyTaxForm(taxform);
    return {
      onBack: self.handleKftRegTaxFormBack,
      onNext: guardNextStep(self.handleKftRegTaxFormNext, nextDisabled),
      nextDisabled,
    };
  }

  if (stepComponent === KftRegForeignTrade) {
    const { foreign_trade, foreigntradeEU } = self.props.company_store || {};
    const nextDisabled = !isEvForeignTradeAnswered(foreign_trade, foreigntradeEU);
    return {
      onBack: self.handleKftRegForeignTradeBack,
      onNext: guardNextStep(self.handleKftRegForeignTradeNext, nextDisabled),
      nextDisabled,
    };
  }

  return null;
};
